import React from 'react'
import PropTypes from 'prop-types'

export const Checked = ({ label, value, handler, id }) => {
  return (
    <div className="form-check">
      <input
        className="form-check-input hyperlink-check-input"
        type="checkbox"
        value={value}
        checked={value}
        onClick={handler}
        data-testid={id}
      />
      <label className="form-check-label hyperlink-check-label">{label}</label>
    </div>
  )
}

Checked.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool,
  handler: PropTypes.func,
  id: PropTypes.string,
}
